import {getListTournament} from '../api/getListTournament';
import {setGetListTournamentAction} from '../action';

const setGetListTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListTournament(params);

            if (data.status === 'success') {
                dispatch(setGetListTournamentAction(data.data))
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListTournament
}